/* global fetch:false Request:false */

const makeRequest = (method, data, path, cb) => {
  const options = {
    method,
    headers: {
      'Content-Type': 'application/json'
    },
    body: data && JSON.stringify(data)
  };

  const request = new Request(`/funeral/proxy.php?csurl=${path}`);

  return fetch(request, options).then(response => {
    return response.json().then(r => {
      if (response.status === 200) {
        return r;
      } else {
        return Promise.reject(r);
      }
    });
  });
};

export default {
  getQuote: (type, data) => makeRequest('POST', { type, ...data }, '/v1/insurance/quotes'),
  createPolicyholder: (data) => makeRequest('POST', data, '/v1/insurance/policyholders'),
  getPolicyholders: (idNumber) => makeRequest('GET', null, `/v1/insurance/policyholders${idNumber ? ('?id_number=' + idNumber) : ''}`),
  createApplication: (data) => makeRequest('POST', data, '/v1/insurance/applications'),
  createPolicy: (data) => makeRequest('POST', data, '/v1/insurance/policies'),
  addPaymentMethod: (policyholderId, data) => makeRequest('POST', data, `/v1/insurance/policyholders/${policyholderId}/payment-methods`),
  updateBeneficiaries: (policyId, data) => makeRequest('PUT', data, `/v1/insurance/policies/${policyId}/beneficiaries`),
  createAttachment: (policyId, data) => makeRequest('POST', data, `/v1/insurance/policies/${policyId}/attachments`),
  updatePolicy: (policyId, data) => makeRequest('PATCH', data, `/v1/insurance/policies/${policyId}`)
};



// WEBPACK FOOTER //
// ./src/api.js